import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const MobileNumberInput = ({ value, onChange, error, disabled }) => {
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    // Update local state when prop value changes
    if (value) {
      // Remove '63' prefix if present for display
      const displayValue = value.startsWith('63') ? value.slice(2) : value;
      setInputValue(displayValue);
    } else {
      setInputValue('');
    }
  }, [value]);

  const handleChange = (e) => {
    const input = e.target.value;

    // Only allow numbers
    const numbersOnly = input.replace(/[^\d]/g, '');

    // Limit to 10 characters
    if (numbersOnly.length <= 10) {
      setInputValue(numbersOnly);

      // Add '63' prefix when sending value to parent
      onChange({
        target: {
          name: 'mobile_number',
          value: numbersOnly ? `63${numbersOnly}` : '',
        },
      });
    }
  };

  return (
    <div className="mobile-input-container">
      <div className={`input-group ${error ? 'is-invalid' : ''}`}>
        <div className="input-group-prepend">
          <span className="input-group-text">+63</span>
        </div>
        <input
          type="text"
          className={`form-control ${error ? 'is-invalid' : ''}`}
          value={inputValue}
          onChange={handleChange}
          placeholder="9XX XXX XXXX"
          disabled={disabled}
          maxLength={10}
          autoComplete="off"
        />
      </div>
      {error && <div className="invalid-feedback d-block">{error}</div>}
    </div>
  );
};

MobileNumberInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  disabled: PropTypes.bool,
};

MobileNumberInput.defaultProps = {
  value: '',
  error: '',
  disabled: false,
};

export default MobileNumberInput;
